import { Caption, Title } from "../ui/typography";
import QuantityButton from "../ui/quantity-button";
import { Button } from "../ui/button";
import { TriangleAlert } from "lucide-react";
import LoadingSkeleton from "@/components/Loading/ProductLoading";

import { useState } from "react";
import { formatToUSD } from "@/app/utils/utility";

import { useRouter } from "next/navigation";
import Image from "next/image";
import { setSelectedProductId } from "@/app/redux/product-management/product-management-slice";
import { useDispatch } from "react-redux";

export default function Product({ product, isLoading, handleAddCart, key }) {
  const [quantity, setQuantity] = useState(1);
  const [inputQuantity, setinputQuantity] = useState(1);
  const router = useRouter();
  const dispatch = useDispatch();
  if (isLoading) return <LoadingSkeleton />;

  // const isDiscountPresent = product?.discountInPercentage > 0;
  const isDiscountPresent = false;
  const productImage = product?.ProductImages[0]?.image_url || "";
  const discountedPrice = product?.EcomInventory?.maximum_selling_price || "$0.00";
  const costPrice = product?.EcomInventory.maximum_selling_price || "$0.00";

  const handleQuantityChange = (productCount = 1) => setQuantity(productCount);

  const handleProductClick = product => {
    router.push(`/product/${encodeURIComponent(product?.product_name)}`);
    dispatch(setSelectedProductId(product?.id));
  };

  return (
    <div className="w-full">
      <header
        onClick={() => handleProductClick(product)}
        className=" h-[210px] lg:h-[310px] w-full bg-midnightIndigo-100 rounded mb-4 flex items-center relative p-5 "
      >
        <div className=" absolute top-[8px] right-[10px] flex">
          <div className=" rounded px-2 py-1 bg-system-crystalWhite mr-0 lg:mr-2">
            <Caption size="xs" variant="regular" className="text-system-warning flex items-center">
              <TriangleAlert className="mr-1 h-[20px] w-[20px]" />
              {product?.EcomInventory?.in_stock} left in Stock
            </Caption>
          </div>
          {isDiscountPresent && (
            <div className="bg-midnightIndigo-400 rounded hidden lg:block px-2 py-1">
              <Caption size="xs" variant="regular" className="text-white">
                -{product?.EcomInventory?.discountInPercentage}%
              </Caption>
            </div>
          )}
        </div>

        <Image src={productImage} width={250} height={250} className="w-[250px] h-[250px] object-contain" />
      </header>
      <section>
        <div>
          <Caption size="xs" className="md:text-[13px]">
            MODEL: {product?.model_number}
          </Caption>

          <Title size="xs" className="md:text-[16px]">
            {product?.product_name?.length > 20 ? `${product?.product_name.slice(0, 15)} ...` : product?.product_name}
            ...
          </Title>
        </div>
        <div className="flex flex-col lg:flex-row items-start  lg:items-end  justify-between mt-4 lg:mt-8 mb-4">
          <div>
            {isDiscountPresent && (
              <Caption className="line-through text-[15px] md:text-[14px]">{formatToUSD(costPrice)}</Caption>
            )}
            <Title size="sm" className="md:text-[16px]">
              {formatToUSD(discountedPrice)}
            </Title>
          </div>
          <div className="w-full lg:w-[96px] mt-4 lg:mt-0">
            <QuantityButton
              product={product}
              onQuantityChange={handleQuantityChange}
              setinputQuantity={setinputQuantity}
            />
          </div>
        </div>
        <Button
          size="xl"
          className="hover:bg-midnightIndigo-400 hover:text-white border-system-grey hover:border-midnightIndigo-400 text-[16px]"
          variant="outline"
          onClick={() => handleAddCart(product, quantity)}
        >
          Add to cart
        </Button>
      </section>
    </div>
  );
}
